import { useAppStore } from '@/lib/store';

export function useAppLanguage() {
  const language = useAppStore((state) => state.language);
  const setLanguage = useAppStore((state) => state.setLanguage);

  return { language, setLanguage };
}
